module.exports = __webpack_public_path__ + "img/90sheji_linggan_2213648589@2x.ab1d1c35.png";